<template>
  <div class="auth">
    <transition name="auth-router" mode="out-in">
      <router-view class="router" />
    </transition>
  </div>
</template>

<script>
export default {
  name: "auth",
};
</script>

<style lang="scss" scoped>
.auth {
  min-height: 120vh;
  display: flex;
  flex-direction: column;
  background-repeat: no-repeat;
  background-size: contain;
  background: -webkit-gradient(linear,
      left top,
      right bottom,
      color-stop(0%, #84cd8c),
      color-stop(100%, #4ca7a3));
}
</style>
